<template>
  <div>
    <page-title title="Admin Reports" />
    <b-row>
      <b-col>
        <b-card class="mt-3" v-if="downloadState == 0">
          <h4 slot="header">Available CSV Exports</h4>
          <ul>
            <li><b-link @click="exportStationsToCsv">All Stations</b-link></li>
            <li><b-link @click="exportRolesToCsv">All Stations Heads and Collectors</b-link></li>
          </ul>
        </b-card>
        <b-card class="mt-3" v-if="downloadState == 1">
          <h4 slot="header">Creating CSV File</h4>
          <div class="text-center">
            <b-spinner label="Spinning"></b-spinner>
          </div>
          <p>Please wait while your report is created...</p>
        </b-card>
        <b-card class="mt-3" v-if="downloadState == 2">
          <h4 slot="header">Download CSV File</h4>
          <p>Your report has been created.</p>
          <b-button @click="downloadState = 0">Export Another Report</b-button>
        </b-card>
        <b-card class="mt-3" v-if="downloadState == 3">
          <h4 slot="header">Error Creating CSV File</h4>
          <p>An unexpected error occurred while exporting the report. This could be caused by attempting to create too large of a report. Verify the date range, stations, and allergens to include.</p>
          <b-button @click="downloadState = 0">Try Again</b-button>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import CrudOperationsMixin from '../Common/CrudOperationsMixin.js'

export default {
  name: "ReportAdmin",
  mixins: [CrudOperationsMixin],
  props: [
  ],
  data() {
    return {
      downloadState: 0
    }
  },
  computed: {
  },
  methods: {
    openCsvFile: function (source, filename) {
      let el = document.createElement('a');
      el.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(source));
      el.setAttribute('download', filename);

      el.style.display = 'none';

      document.body.appendChild(el);
      el.click();
      document.body.removeChild(el);
    },
    exportStationsToCsv: function () {
      this.downloadState = 1;

      this.query('/graphql/management', {
        query: `
          query  {
            exportStationsToCsv
          }`,
        variables: {
        }}, (data) => {
          this.openCsvFile(data.exportStationsToCsv, 'AllStations.csv');

          this.downloadState = 2;
        }, () => { this.downloadState = 3; }, null, null, null);
    }  ,
    exportRolesToCsv: function () {
      this.downloadState = 1;

      this.query('/graphql/management', {
        query: `
          query  {
            exportRolesToCsv
          }`,
        variables: {
        }}, (data) => {
          this.openCsvFile(data.exportRolesToCsv, 'AllStations.csv');

          this.downloadState = 2;
        }, () => { this.downloadState = 3; }, null, null, null);
    }  
  },
  watch: {
  },
  mounted () {
  }
};
</script>